module.exports = __webpack_public_path__ + "static/media/home-slider-banner-1.f2d0aaea.png";